module.exports = __webpack_public_path__ + "img/senguo_login_bg_img.403ac6e3.png";